var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 446,
    viewBox: "0 0 17 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.158 441.265C16.158 443.751 14.136 445.773 11.652 445.773H4.508C2.022 445.773 0 443.751 0 441.265V432.509C0 430.023 2.022 428.001 4.508 428.001H11.652C14.136 428.001 16.158 430.023 16.158 432.509V441.265Z",
    fill: "#ED1457"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0791 3.05176e-05V437.332",
    stroke: "#ED1457",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLine);
export default __webpack_public_path__ + "static/media/login-line.be9bb545615132508abc8c59ef55e157.svg";
export { ForwardRef as ReactComponent };